export const config = {
    appname: '',
    client_id: '', // App ID
    facebook_app_id: '', // Facebook App ID (Should be the same)
    debug: false, //enable console.log

    // ------------- Staging Settings ----------------
    api: 'stg1service',
    agency_id: '',
    bzbsUrlOldSupport: 'https://stg.buzzebees.com',
    bzbsUrl: 'https://stg1servicecenter.buzzebees.com.my',
    bzbsUrlWithPrefix: 'https://{prefix}.buzzebees.com.my',
    bzbsModuleUrl: 'https://stg-module-app.azurewebsites.net',
    apiShoppingCartUrl: 'https://stg-module-shoppingcart.azurewebsites.net',
    webShoppingCartUrl: 'https://stg-web-shoppingcart-apiservice.azurewebsites.net',
    bzbsBlobUrl: 'https://stgbuzzebeesmy.blob.core.windows.net',
    miscUrl: 'https://stgmisc.buzzebees.com',
    bzbsGaId: '',
    liffId: '',
    // ------------------ End Settings ---------------------
    fbLogOnUrl: 'https://www.facebook.com/dialog/oauth?',
    fbPermissions: [
        'email',
    ],

    firebase: {
        apiKey: "",
        authDomain: "",
        databaseURL: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: ""
    },
    bitkubConfig: {
        endpoint: "https://accounts.bitkubnext.com",
        clientId: "6274a88df5c1ee5fad18a3fb",
        redirectUri: "/bitkub/callback",
        apiUrl: "https://api.bitkubnext.io",
    },
};
